// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","app__body":"App_app__body__ccdAK"};